import { isPresent } from '@ember/utils';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  catalogObjectToken: attr(String),
  version: attr(Number)
}).reopenClass({
  fromCatalogModel(catalogModel) {
    if (isPresent(catalogModel)) {
      return this.create({
        catalogObjectToken: catalogModel.id,
        version: catalogModel.version
      });
    }
    return undefined;
  }
});